import {isNullOrEmpty, convertDateTimeToDate, insertAt} from 'app/utilities/StringHelpers/StringHelpers';
import {reportsDictionary} from './reportDwh';

export const PersonalPricePlanStep = {
  Initial: 'Initial',
  GeneralMessage: 'GeneralMessage',
  SelectBan: 'SelectBan',
  SelectPackage: 'SelectPackage',
  SelectSubscribers: 'SelectSubscribers',
  SuccessPage: 'SuccessPage',
};

export enum subscriberErrorType {
  isTransferInProgress = 'isTransferInProgress',
  isModemSubscriber = 'isModemSubscriber',
  isAccountTypeNotValid = 'isAccountTypeNotValid',
  isSusspendedSubscriber = 'isSusspendedSubscriber',
  isKasherSubscriber = 'isKasherSubscriber',
  isFeauturePricePlan = 'isFeauturePricePlan',
  withoutAssetExternalId = 'withoutAssetExternalId',
}

var supportNumber = () => window.Config?.technicalSupportPhone;


export const subscriberError: {
  [key: string]: {
    errorMessage: string;
    errorDescription: string;
    errorBanMessage?: string;
    errorBanDescription?: string;
    checkFunction: (product: any) => boolean;
  };
} = {
  [subscriberErrorType.isTransferInProgress]: {
    errorMessage: 'המנוי נמצא בתהליך  ניוד',
    errorDescription: `המנוי נמצא בתהליך ניוד.\nלפרטים ניתן להמשיך עם נציג ב ${supportNumber()}`,
    checkFunction: (product: any) => product?.npStatus == 'BPO',
  },
  [subscriberErrorType.isModemSubscriber]: {
    errorMessage: 'אין אפשרות לשנות חבילה למנוי גלישה בלבד',
    errorDescription: `הקו מיועד לגלישה בלבד.\nלשינוי ניתן להמשיך עם נציג ב ${supportNumber()}`,
    checkFunction: (product: any) => product?.modemInd == true,
  },
  [subscriberErrorType.isAccountTypeNotValid]: {
    errorMessage: 'אין אפשרות לשנות חבילה למנוי עסקי',
    errorBanMessage: 'אין אפשרות לשנות חבילה לחשבון עסקי',
    errorBanDescription: 'חשבון זה הינו עסקי, יש לפנות לאיש הקשר בארגונך לשינוי חבילה',
    errorDescription: 'מנוי זה הינו עסקי, יש לפנות לאיש הקשר בארגונך לשינוי חבילה',
    checkFunction: (product: any) => product?.accountType == 'C' || product?.accountType == 'M',
  },
  [subscriberErrorType.isSusspendedSubscriber]: {
    errorMessage: 'אין אפשרות לשנות חבילה למנוי מושהה',
    errorDescription: `המנוי בסטטוס מושהה. לביטול או למידע נוסף ניתן להמשיך עם נציג ב ${supportNumber()}`,
    checkFunction: (product: any) => product?.subStatus == 'S',
  },
  [subscriberErrorType.isKasherSubscriber]: {
    errorMessage: 'אין אפשרות לשנות חבילה למנוי כשר',
    errorDescription: 'זיהינו שהמנוי כשר ולכן לא יכול לשנות חבילה',
    checkFunction: (product: any) => product?.isKosher == true,
  },
  [subscriberErrorType.isFeauturePricePlan]: {
    errorMessage: 'המנוי נמצא כבר בתהליך עדכון חבילה ',
    errorDescription: `המנוי נמצא בתהליך עדכון חבילה,לפרטים ניתן להמשיך עם נציג ב ${supportNumber()}`,
    checkFunction: (product: any) => product?.futurePPInd == true,
  },
  [subscriberErrorType.withoutAssetExternalId]: {
    errorMessage: 'אין אפשרות לשנות חבילה למנוי זה באתר',
    errorDescription: `לשינוי חבילה למנוי זה, ניתן להמשיך עם נציג ב${supportNumber()}`,
    checkFunction: (product: any) => isNullOrEmpty(product?.assetExternalId),
  },
};

export const getDisabledError = (product) => {
  for (let error of Object.values(subscriberError)) {
    if (error.checkFunction(product)) {
      return error;
    }
  }
  return null;
};

export const getTransitEffectiveDateText = (isImmediatePlan: boolean, effectiveDate: string) => {
  if (isImmediatePlan) {
    return `החבילה תיכנס לתוקף החל מהיום ${convertDateTimeToDate(new Date())}`;
  } else {
    const baseText = 'החבילה תכנס לתוקף במחזור החיוב הבא';
    return effectiveDate ? `${baseText}, ${effectiveDate}` : baseText;
  }

};

const getSubscribersWithSameFamilyPlan = (subscribersList: any) => {
  const GroupedSubscribers = subscribersList.reduce((acc, obj) => {
    if(obj.brbInd){
      const key = `${obj.currentPricePlan}`;
      (acc[key] = acc[key] || []).push(obj);
    }
    return acc;
  }, {});

  return Object.values(GroupedSubscribers).filter((group: any) => group?.length > 1)?.[0] || [];
}

export const getMemebersNames = (subscribersList: any ,withoutEnding:boolean = false) => {
  if(subscribersList.length == 0) return '';
  subscribersList = subscribersList.map((subscriber) => DisplayNameOrNumber(subscriber));
  if(withoutEnding){
    return subscribersList.join(', ');
  }else{
    return subscribersList.slice(0, -1).join(', ') +
    (subscribersList.length > 1 ? ' ו-' : '') +
    (subscribersList[subscribersList.length - 1] ?? '');
  }

}

const getNameOfSubscribersWithSameFamilyPlan = (subscribersList: any) => {
   const subscriberWithSameFamilyPlan: any = getSubscribersWithSameFamilyPlan(subscribersList);
   return subscriberWithSameFamilyPlan?.length > 0 ? getMemebersNames(subscriberWithSameFamilyPlan , false) : '';

}
export const DisplayNameOrNumber = (subscriber) => {
  if (!subscriber) return '';
  var subsriberNo = insertAt(subscriber.subscriberNo, 3, '-');
  return !isNullOrEmpty(subscriber.productFirstName) ? `${subscriber.productFirstName}` : subsriberNo;
};

export const getSelectedSubscribersWithSameFamilyPlan = (subscribersList: any, selectedSubscribers: any) => {
  var subscriberWithSameFamilyPlan: any = getSubscribersWithSameFamilyPlan(subscribersList);
   subscribersList = subscriberWithSameFamilyPlan.filter((subscriber: any) => selectedSubscribers.includes(subscriber.subscriberNo));
  return subscribersList.length > 0 ? getMemebersNames(subscribersList, true) : '';

}


export const getOtherSubscribersWithSameFamilyPlan = (subscribersList: any, selectedSubscribers: any ) => {
     var subscriberWithSameFamilyPlan: any = getSubscribersWithSameFamilyPlan(subscribersList);
     var otherSubscribers = [];
      otherSubscribers = subscriberWithSameFamilyPlan.filter((subscriber: any) => !selectedSubscribers.includes(subscriber.subscriberNo));
     return otherSubscribers;
}


export const getOtherSubscribersNamesWithSameFamilyPlan = (subscribersList: any, selectedSubscribers: any , breakLine: boolean = false) => {
  var otherSubscribers = getOtherSubscribersWithSameFamilyPlan(subscribersList, selectedSubscribers);
  return otherSubscribers.length > 0 ? getMemebersNames(otherSubscribers , breakLine) : '';
}

export const selectSomeSubscibersThereInFamilyPlan = (subscribersList: any, selectedSubscribers: any) => {
  var subscriberWithSameFamilyPlan: any = getSubscribersWithSameFamilyPlan(subscribersList);
  var selectedSubscribers = subscriberWithSameFamilyPlan.filter((subscriber: any) => selectedSubscribers.includes(subscriber.subscriberNo));
  return selectedSubscribers?.length >= 1;
}

export const messageData = {
  ERROR: {
    icon: require('./icons/error2.svg'),
    title: 'משהו השתבש',
    subTitle: 'נציג שירות שלנו יחזור אליך בהקדם\nלמספר {processedSubscriberNo}',
    buttonText: 'לאזור האישי',
    buttonList: [
      {
        text: 'לאזור האישי',
        click: 'privateLobby',
        color: 'white',
      },
    ],
    report: reportsDictionary.GENERAL_ERROR,
    isPopup: false,
    width: '339px',
  },
  NO_CELLULAR_PLAN: {
    icon: require('./icons/error.svg'),
    title: 'נראה שאין לך מנוי סלולר',
    subTitle: 'רוצה להצטרף לאחת מחבילות הסלולר שלנו?',
    report: reportsDictionary.ERROR_NO_CELLULAR,
    buttonList: [
      {
        text: 'לרכישת מנוי סלולר',
        click: 'getNewCellularPlan',
        color: 'primaryColor',
      },
      {
        text: 'לאזור האישי',
        click: 'privateLobby',
        color: 'white',
      },
    ],
    isPopup: false,
  },
  CANNOT_CHANGE_FAMILY_PLAN: {
    icon: require('./icons/error.svg'),
    title: 'אין אפשרות לעדכן חבילה משפחתית חדשה',
    subTitle: `בחשבונך קיימת כיום חבילה משפחתית,\nאחד המנויים בחבילה לא יכול להתעדכן כרגע.\nלמידע נוסף ניתן להמשיך עם נציג ב ${supportNumber()}`,
    buttonList: [
      {
        text: 'לבחירת חבילה אחרת',
        click: 'selectOtherPricePlan',
        color: 'primaryColor',
      },
      {
        text: 'לאזור האישי',
        click: 'privateLobby',
        color: 'white',
      },
    ],
    report: reportsDictionary.ERROR_UNABLE_UPDATE_FAMILY_PACKAGE,
    isPopup: false,
  },

  SHOULD_SELECT_ALL_SUBSCRIBERS: {
    icon: require('./icons/error.svg'),
    title: 'יש לצרף לחבילה גם את {getUnselectesSubscribersWithSameFamilyPlan} ',
    subTitle: 'לעדכון חבילה משפחתית חדשה, יש לצרף אליה את המנויים הקיימים בחבילה המשפחתית הקיימת',
    buttonList: [
      {
        text: 'חזרה לבחירת מנויים',
        click: 'closePopup',
        color: 'primaryColor',
      },
    ],
    isPopup: true,
  },

  POPUP_WARNING_EXIT_PLAN_DISPLAY: {
    icon: require('./icons/error2.svg'),
    title: `שינוי החבילה ישפיע על חלק מהמנויים`,
    subTitle:  ` המנויים : \n  {getNameOfSubscribersWithSameFamilyPlan}\n  שייכים לחבילה משפחתית .\n
    מעבר של :  \n {getSelectedSubscribersWithSameFamilyPlan} בלבד  \n ישפיע על מחירי שאר המנויים בחבילה הקיימת.` ,
    buttonList: [
      {
        text: 'חזרה לבחירת מנויים',
        click: 'closePopup',
        report: reportsDictionary.POPUP_WARNING_EXIT_PLAN_BACK_CLICK,
        color: 'white',
      },
      {
        text: 'בסדר, תעדכנו לי',
        click: 'updatePricePlan',
        color: 'primaryColor',
        report: reportsDictionary.POPUP_WARNING_EXIT_PLAN_OK_CLICK,
      },
    ],
    width: '339px',
    isPopup: true,
    report: reportsDictionary.POPUP_WARNING_EXIT_PLAN_DISPLAY,
  },
  OnlyDisableBan: {
    icon: require('./icons/error.svg'),
    title: 'נראה שאתה מנוי עסקי',
    subTitle: 'לשינוי חבילה ניתן לפנות לאיש הקשר בארגונך',
    buttonList: [
      {
        text: 'לרכישת מנוי סלולר',
        click: 'getNewCellularPlan',
        color: 'primaryColor',
      },
      {
        text: 'לאזור האישי',
        click: 'privateLobby',
        color: 'white',
      },
    ],
    isPopup: false,
  },
};

export const placeHolderFunctions = {
  getSelectedSubscribersWithSameFamilyPlan: (state: any) => getSelectedSubscribersWithSameFamilyPlan(state.subscribersList, state.selectedSubscribers) ,
  getUnselectesSubscribersWithSameFamilyPlan: (state: any) => getOtherSubscribersNamesWithSameFamilyPlan(state.subscribersList, state.selectedSubscribers, false),
  getNameOfSubscribersWithSameFamilyPlan: (state: any) => getNameOfSubscribersWithSameFamilyPlan(state.subscribersList),
};

export const stepBarList = [
  {
    icon: require('./icons/account.svg'),
    title: 'בחירת חשבון',
    conditionToShow: (state: any) => true,
  },
  {
    icon: require('./icons/phone.svg'),
    title: 'בחירת חבילה',
    conditionToShow: (state: any) => true,
  },
  {
    icon: require('./icons/users.svg'),
    title: 'שיוך מנויים לחבילה',
    conditionToShow: (state: any) => {
      if (state.productsByBan && isNullOrEmpty(state.selectedBan)) {
        return state.productsByBan.some((b) => b.products.length > 1);
      }
      return state.subscribersList && state.subscribersList.length > 1;
    },
  },
  {
    icon: require('./icons/success.svg'),
    title: 'עודכן בהצלחה!',
    conditionToShow: (state: any) => true,
  },
];
